import React, { useEffect, useState } from "react";
import { Chat, Channel, MessageList, Window } from "stream-chat-react";
import useChatClient from "../StatesStore/ChatClient";
import "stream-chat-react/dist/css/v2/index.css";
import { UserAuth } from "../Context";
import { EmojiPicker } from "stream-chat-react/emojis";
import { encodeToMp3 } from "stream-chat-react/mp3-encoder";
import "./Chat.css";
import SideBar from "./SideBar";
import LoadingSpinner from "../UserProfile/LoadingSpinner";
import { ChannelHeader } from "./ChannelHeader";
import CustomMessageInput from "./CustomMessageInput";
import ProductsInChat from "./ProductsInChat";
import useThemeState from "../StatesStore/Theme";
import { CustomAttachmentSelector } from "./CustomAttachmentSelector";
import CustomAttachment from "./CustomAttachment";
import { useParams } from "react-router-dom";

function Chat2() {
  const { user } = UserAuth();
  const { theme } = useThemeState();
  const client = useChatClient((state) => state.client);
  const { chatId, type } = useParams(); // get the channel ID from URL
  const [activeChannel, setActiveChannel] = useState(null);
  const [loadedFirstTime, setLoadedFirstTime] = useState(false);
  // console.log("client", client);
  useEffect(() => {
    if (!client || !chatId) return;
    const loadChannel = async () => {
      const channel = client.channel(
        type === "user" ? "messaging" : "team",
        chatId
      ); // assumes "messaging" type
      console.log("channel", channel);
      await channel.watch(); // fetch messages and details
      setActiveChannel(channel); // set it as the current active channel
      setLoadedFirstTime(true);
    };

    loadChannel();
  }, [client, chatId]);
  if (!client) {
    return <LoadingSpinner />;
  }

  const containerStyle = {
    display: "flex",
    height: "-webkit-fill-available",
    width: "100%",
    overflow: "hidden",
    // gap: "0.5rem",
  };

  const channelWindowStyle = {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
    borderRadius: "0px 4px 4px 0px",
    height: "93vh",
    width: "76.4vw",
    marginRight: "20px",
  };

  if (!user) return;
  return (
    <>
      <style>
        {`
        .str-chat {
          --str-chat__border-radius-circle: 4px; 
          --str-chat__avatar-background-color: #dddddd;
          --str-chat__avatar-color:#222222;
           --str-chat__channel-preview-active-background-color: #e7f0fd;
        }
        .str-chat__li{
           padding-inline: 0.5rem !important;
        }
        // .str-chat__message .str-chat__message-bubble  {
        //   border-radius: 0.5rem !important;
        //   background-color: transparent !important;
        // }
           
      `}
      </style>
      {/* <button
        className="border-0 rounded-2 me-2 icon-md btn btn-light p-0 position-absolute z-1 d-lg-none mb-4"
        type="button"
        data-bs-toggle="offcanvas"
        data-bs-target="#offcanvasSideChatbar"
        aria-controls="offcanvasSideChatbar"
      >
        <span className="btn btn-primary p-2">
          <List className="fs-4" />
        </span>
      </button> */}
      <Chat
        client={client}
        customClasses={{
          channelList: `str-chat__theme-${theme} str-chat__channel-list`,
          channel: `str-chat__theme-${theme} str-chat__channel`,
        }}
      >
        <div style={containerStyle}>
          <SideBar
            chatId={chatId}
            loadedFirstTime={loadedFirstTime}
            setLoadedFirstTime={setLoadedFirstTime}
            setActiveChannel={setActiveChannel}
          />

          <div style={channelWindowStyle}>
            <Channel
              channel={activeChannel}
              EmojiPicker={EmojiPicker}
              Attachment={CustomAttachment}
              enrichURLForPreview
              AttachmentSelector={CustomAttachmentSelector}
            >
              <Window>
                {/* <Users /> */}
                <ChannelHeader />
                <ProductsInChat />
                {/* <ChannelHeader /> */}
                <MessageList
                  messageActions={["edit", "delete", "quote", "react"]}
                  closeReactionSelectorOnClick={true}
                  additionalMessageInputProps={{
                    urlEnrichmentConfig: { enrichURLForPreview: true },
                  }}
                  // renderMessages={customRenderMessages}
                />
                <CustomMessageInput
                  audioRecordingConfig={{
                    transcoderConfig: { encoder: encodeToMp3 },
                  }}
                  audioRecordingEnabled
                  urlEnrichmentConfig={{ enrichURLForPreview: true }}
                />
              </Window>
            </Channel>
          </div>
        </div>
      </Chat>
    </>
  );
}

export default Chat2;
